module.exports = __webpack_public_path__ + "static/spiele-aff3301c400f15255bc12d7de9ef7254.jpg";